import { render, staticRenderFns } from "./ent-auto-select.vue?vue&type=template&id=4a283f52&scoped=true"
import script from "./ent-auto-select.vue?vue&type=script&lang=js"
export * from "./ent-auto-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a283f52",
  null
  
)

export default component.exports